import UnfilledButton from "@/components/common/unfilled-button";
import Link from "next/link";
import styles from "./styles/upgrade-subscription-button.module.scss";
import FilledButton from "@/components/common/filled-button";
import { useMobile } from "@/hooks/use-responsive";

interface GetStartedButtonProps {
  productId: string;
  isMostPopularSubscription?: boolean;
  couponUrlParam: string;
  onClick: () => void;
}

const UpgradeSubscriptionButton = ({
  productId,
  isMostPopularSubscription,
  couponUrlParam,
  onClick,
}: GetStartedButtonProps) => {
  const { isMobile } = useMobile();
  const pageTemplateId = isMobile ? "19987" : "18636";
  return (
    <Link
      href={`https://store.payproglobal.com/checkout?products[1][id]=${productId}&page-template=${pageTemplateId}${couponUrlParam}`}
      target={"_blank"}
      className={styles.button}
      onClick={onClick}
    >
      {isMostPopularSubscription ? (
        <FilledButton
          text={"UPGRADE"}
          padding={"10px 20px"}
          backgroundColor={"#FF5722"}
        />
      ) : (
        <UnfilledButton
          borderColor={"#F9A825"}
          text={"UPGRADE"}
          padding={"10px 20px"}
        />
      )}
    </Link>
  );
};

export default UpgradeSubscriptionButton;
